/*
 ** vue router: Lucky Draw
 */
import type { RouteRecordRaw } from 'vue-router';

const vrtLuckyDraw: RouteRecordRaw = {
  path: '/eservices/luckydraw',
  name: 'vrtLuckyDraw',
  component: () => import('src/layouts/vcleSystem.vue'),
  meta: {
    title: 'Lucky Draw',
    requiresAuth: true,
  },
  children: [
    {
      path: '',
      name: 'vrtLuckyDrawList',
      component: () => import('./vpgLuckyDrawList.vue'),
      meta: {
        title: 'Lucky Draw List',
        breadcrumb: 'List',
      },
    },
    {
      path: 'create',
      name: 'vrtLuckyDrawCreate',
      component: () => import('./vpgLuckyDrawCreate.vue'),
      meta: {
        title: 'Create Lucky Draw',
        breadcrumb: 'Create',
        requiresAuth: true,
      },
    },
    {
      path: 'details',
      name: 'vrtLuckyDrawDetails',
      component: () => import('./vpgLuckyDrawDetails.vue'),
      meta: {
        title: 'Lucky Draw Details',
        breadcrumb: 'Details',
      },
    },
    {
      path: 'edit',
      name: 'vrtLuckyDrawEdit',
      component: () => import('./vpgLuckyDrawEdit.vue'),
      meta: {
        title: 'Edit Lucky Draw',
        breadcrumb: 'Edit',
        requiresAuth: true,
      },
    },
    {
      path: 'draw',
      name: 'vrtLuckyDrawDraw',
      component: () => import('./vpgLuckyDrawDraw.vue'),
      meta: {
        title: 'Lucky Draw - Drawing',
        breadcrumb: 'Draw',
        requiresAuth: true,
      },
    },
    {
      path: 'operate',
      name: 'vrtLuckyDrawOperate',
      component: () => import('./vpgLuckyDrawOperate.vue'),
      meta: {
        title: 'Lucky Draw - Operate',
        breadcrumb: 'Operate',
        requiresAuth: true,
      },
    },
    {
      path: 'winners',
      name: 'vrtLuckyDrawWinners',
      component: () => import('./vpgLuckyDrawWinners.vue'),
      meta: {
        title: 'Lucky Draw Winners',
        breadcrumb: 'Winners',
      },
    },
    {
      path: 'participants',
      name: 'vrtLuckyDrawParticipants',
      component: () => import('./vpgLuckyDrawParticipants.vue'),
      meta: {
        title: 'Lucky Draw Participants',
        breadcrumb: 'Participants',
      },
    },
    {
      path: 'admin',
      name: 'vrtLuckyDrawAdmin',
      component: () => import('./vpgLuckyDrawAdmin.vue'),
      meta: {
        title: 'Lucky Draw Administration',
        breadcrumb: 'Admin',
        requiresAuth: true,
        requiresAdmin: true,
      },
    },
  ],
};

export default vrtLuckyDraw;
